import { createContext } from 'react';
var initialContext = {};
export var GuardContext = createContext(initialContext);
